import europe from '../../json/europe.json';

class DataService {
  constructor() {
    // Set default region. User data region will be set via UserDataService.
    this._data = europe;
  }

  get data() {
    let result = [];

    // Remove the last item because it is the wsd (asset) id
    for (let row of this._data) {
      result.push(row.slice(0, -1));
    }

    return result;
  }

  assetIdFor(name) {
    for (let row of this._data) {
      if (row[0].toLowerCase() === name.toLowerCase()) {
        return parseInt(row[row.length - 1]);
      }
    }
  }

  get rowsWithoutHeader() {
    return this.data.slice(1);
  }

  get headers() {
    return this.data[0];
  }

  headerOfColumn(columnIndex) {
    return this.headers[columnIndex];
  }

  aggregateRowsByColumn(columnIndex, rows = null) {
    rows = rows || this.rowsWithoutHeader;
    let result = [];

    for (let row of rows) {
      if (!result.includes(row[columnIndex])) {
        result.push(row[columnIndex]);
      }
    }

    return result;
  }

  aggregateRowsByColumns(columnIndexes, rows = null) {
    let result = {};

    for (let columnIndex of columnIndexes) {
      result[columnIndex] = this.aggregateRowsByColumn(columnIndex, rows);
    }

    return result;
  }

  // Filters `data` (rows) based on a `columnIndex` and whether this column's value is included in `values`
  filter(data, columnIndex, values) {
    if (!values || values.length < 1) {
      return data;
    }

    let result = [];

    for (let row of data) {
      if (values.includes(row[columnIndex])) {
        result.push(row);
      }
    }

    return result;
  }

  filterDataBySearchTerm(data, columnIndex, searchTerm) {
    let result = [];

    for (let row of data) {
      if (row[columnIndex].toLowerCase().includes(searchTerm.toLowerCase())) {
        result.push(row);
      }
    }

    return result;
  }
}

export let dataService = new DataService();
